import { type Offer } from 'schema-dts'

import {
  type PimProductV11,
  PimProductV1StockStatusEnum,
} from '@redteclab/api/clients/bully'

import { productAccessorGetOfferByIdOrDefault } from '../../model/productAccessor/productAccessorGetOfferByIdOrDefault'

import { getEligibleQuantitySchema } from './getEligibleQuantitySchema'
import { getIsoDateForTomorrow } from './getIsoDates'

export const getOfferSchema = (
  product: PimProductV11,
  isMarketplace: boolean,
  withEligibleQuantity = false,
): Offer => {
  const bestOffer = productAccessorGetOfferByIdOrDefault({
    isMarketplace,
    offers: product.offers,
  })

  return {
    '@type': 'Offer',
    availability:
      product.stock_status === PimProductV1StockStatusEnum.Available
        ? 'https://schema.org/InStock'
        : 'https://schema.org/SoldOut',
    eligibleQuantity:
      withEligibleQuantity && product.package_size
        ? getEligibleQuantitySchema(product.package_size)
        : undefined,
    itemCondition: 'https://schema.org/NewCondition',
    price: bestOffer?.offerPrice?.price,
    priceCurrency: bestOffer?.offerPrice?.currency ?? 'EUR',
    priceValidUntil: getIsoDateForTomorrow(),

    url: product.canonical_url,
  }
}
